module.exports = __webpack_public_path__ + "img/head-bg.78371a07.png";